
import isEmpty from 'lodash/isEmpty'

import { trackClick } from '@tracking/events'

import Picker from '../Picker'
import PickersList from '../PickersList'

import ColorRound from './ColorRound'
import translations from './PickerColor.translations'

const MAX_COLORS = 6

export default {
  components: {
    PickersList,
    Picker,
  },

  props: {
    activeBackboxGrade: {
      type: Number,
      default: 0,
    },
    displayVariant: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    clickOnLinkPicker: {
      type: Function,
      default: () => {},
    },
    loadingId: {
      type: String,
      default: null,
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
  },

  computed: {
    translations: () => translations,
    ColorRound: () => ColorRound,

    displayColors() {
      return this.displayVariant && !isEmpty(this.colors)
    },

    shownColors() {
      return MAX_COLORS
    },

    colorsWithLink() {
      return this.colors.map((color) => ({
        ...color,
        link: {
          ...color.link,
          hash: { l: this.activeBackboxGrade, scroll: false },
        },
        isLoading: color.id === this.loadingId,
      }))
    },

    hasLoadingId() {
      return this.loadingId !== null
    },
  },

  methods: {
    colorClick({ selected, name, id }) {
      if (!selected) {
        trackClick({ zone: 'color_picker', name })
      }
      this.clickOnLinkPicker(id)
    },
  },
}
